import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-portal-daily",
  "use": "icon-leo-portal-daily-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-portal-daily\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<rect x=\"192\" y=\"224\" width=\"640\" height=\"576\" rx=\"40\" /><path d=\"M192 224h640v128H192z\" /><path d=\"M320 192h64v128h-64zM640 192h64v128h-64z\" /><path d=\"M320 448h384v64H320zM320 560h256v64H320z\" fill=\"#fff\" /><circle cx=\"704\" cy=\"672\" r=\"64\" fill=\"#fff\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-portal-daily.svg
// module id = Yo5i
// module chunks = 546